module.exports = __webpack_public_path__ + "static/media/React.e44145a1.png";